import { useAccountScope } from '../context/AccountScope';
import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
import UsersPage from './UsersPage';
import DevicesAdminPage from './DevicesAdminPage';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(isMobileLayout);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return isMobile;
}

function formatearFecha(fecha) {
  if (!fecha) return '—';
  return new Date(fecha).toLocaleString('es-CO', {
    timeZone: 'America/Bogota', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit'
  });
}

function AdministrationPage() {
  const { fetch, account: scopeAccount, actor, refreshAccountScope } = useAccountScope();
  const isMobile = useIsMobile();
  const currentRole = scopeAccount.role;

  const [tabActiva, setTabActiva] =
    useState('usuarios');

  const [licenseTab, setLicenseTab] =
    useState('resumen');

  const [licenseStats, setLicenseStats] =
    useState({
      available: 0,
      active: 0,
      expiring: 0,
      expired: 0
    });

  async function cargarStatsLicencias() {
    try {
      const token =
        localStorage.getItem('token');

      const response =
        await fetch('/api/licenses/stats', {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        });

      const data =
        await response.json();

      if (data.success) {
        setLicenseStats(data.stats);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(
        'Error cargando estadísticas de licencias:',
        error
      );
    }
  }

  useEffect(() => {
    if (tabActiva === 'licencias') {
      cargarStatsLicencias();
    }
  }, [tabActiva]);

  async function crearLicencias(quantity) {
    try {
      const token =
        localStorage.getItem('token');

      const response =
        await fetch(
          '/api/licenses/create',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Authorization:
                `Bearer ${token}`
            },
            body: JSON.stringify({
              quantity: Number(quantity)
            })
          }
        );

      const data =
        await response.json();

      if (data.success) {
        alert(
          `Se crearon ${quantity} licencias correctamente`
        );

        refreshAccountScope();
      } else {
        alert(data.message);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);
      alert('Error creando licencias');
    }
  }

  const getTabStyle = (tab) => {
    if (tabActiva === tab) {
      return isMobile ? tabActiveMobile : tabActive;
    }

    return isMobile ? tabStyleMobile : tabStyle;
  };

  const getActionStyle = (tab) => {
    if (licenseTab === tab) {
      return isMobile ? actionButtonActiveMobile : actionButtonActive;
    }

    return isMobile ? actionButtonMobile : actionButton;
  };
  if (!['super_admin', 'admin_empresa', 'administrador'].includes(currentRole)) {
    return (
      <div style={{ padding: '32px', color: '#0f172a' }}>
        Esta cuenta de usuario no administra otras cuentas ni licencias. Sus datos y preferencias están en Mi cuenta y Configuración.
      </div>
    );
  }

  return (
   <div
  style={{
    flex: 1,
    background: '#f8fafc',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    boxSizing: 'border-box',
    paddingTop: isMobile ? 'calc(58px + env(safe-area-inset-top, 0px))' : '0',
    paddingBottom: isMobile ? 'calc(100px + env(safe-area-inset-bottom, 0px))' : '0'
  }}
>
      <div
        style={{
          padding: isMobile
            ? '22px 14px 0'
            : '34px 40px 0'
        }}
      >
        <h1 style={isMobile ? titleStyleMobile : titleStyle}>
          Administración
        </h1>
        <p style={isMobile ? subtitleStyleMobile : subtitleStyle}>{scopeAccount.name}</p>

        <p style={isMobile ? subtitleStyleMobile : subtitleStyle}>
          Gestiona usuarios, empresas,
          licencias, dispositivos y permisos.
        </p>

        <div style={isMobile ? tabsContainerMobile : tabsContainer}>
          <button
            onClick={() =>
              setTabActiva('usuarios')
            }
            style={getTabStyle('usuarios')}
          >
            Cuentas
          </button>

          <button
            onClick={() =>
              setTabActiva('licencias')
            }
            style={getTabStyle('licencias')}
          >
            Licencias
          </button>

          <button
            onClick={() =>
              setTabActiva('dispositivos')
            }
            style={getTabStyle('dispositivos')}
          >
            Dispositivos
          </button>

          <button
            onClick={() =>
              setTabActiva('movimientos')
            }
            style={getTabStyle('movimientos')}
          >
            Movimientos
          </button>


          {actor?.role === 'super_admin' && (
            <button
              onClick={() => setTabActiva('camaras')}
              style={getTabStyle('camaras')}
            >
              Cámaras
            </button>
          )}

        </div>
      </div>

      {tabActiva === 'usuarios' && (
        <UsersPage />
      )}

      {tabActiva === 'dispositivos' && (
        <DevicesAdminPage />
      )}

{tabActiva === 'movimientos' && (
  <DeviceMovementForm />
)}

      {tabActiva === 'camaras' && actor?.role === 'super_admin' && (
        <CameraAdminPanel />
      )}

      {tabActiva === 'licencias' && (
        <div style={isMobile ? licenseWrapperMobile : licenseWrapper}>
          <div style={isMobile ? licenseHeaderMobile : licenseHeader}>
            <div>
              <h2 style={isMobile ? sectionTitleMobile : sectionTitle}>
                Gestión de licencias
              </h2>

              <p style={isMobile ? sectionSubtitleMobile : sectionSubtitle}>
                Administra licencias anuales,
                renovaciones, transferencias,
                asignaciones y vencimientos.
              </p>
            </div>

            {scopeAccount.role === 'super_admin' && (
              <button
                style={isMobile ? primaryButtonMobile : primaryButton}
                onClick={() => {
                  const quantity = prompt(
                    '¿Cuántas licencias deseas crear?'
                  );

                  if (!quantity) return;

                  crearLicencias(quantity);
                }}
              >
                + Generar lote
              </button>
            )}
          </div>

          <div style={isMobile ? cardsGridMobile : cardsGrid}>
            <LicenseCard
              title="Disponibles"
              value={licenseStats.available || 0}
              description="Sin asignar"
              isMobile={isMobile}
            />

            <LicenseCard
              title="Activas"
              value={licenseStats.active || 0}
              description="En uso"
              isMobile={isMobile}
            />

            <LicenseCard
              title="Por vencer"
              value={licenseStats.expiring || 0}
              description="Próximos 30 días"
              isMobile={isMobile}
            />

            <LicenseCard
              title="Expiradas"
              value={licenseStats.expired || 0}
              description="Requieren renovación"
              isMobile={isMobile}
            />
          </div>

          <div style={isMobile ? licenseActionsMobile : licenseActions}>
            <button
              onClick={() =>
                setLicenseTab('resumen')
              }
              style={getActionStyle('resumen')}
            >
              Resumen
            </button>

            {['super_admin', 'admin_empresa'].includes(currentRole) && (
              <button onClick={() => setLicenseTab('transferir')}
                style={getActionStyle('transferir')}>
                Transferir
              </button>
            )}

            <button
              onClick={() =>
                setLicenseTab('asignar')
              }
              style={getActionStyle('asignar')}
            >
              Asignar
            </button>

            <button
              onClick={() =>
                setLicenseTab('renovar')
              }
              style={getActionStyle('renovar')}
            >
              Renovar
            </button>

            <button
              onClick={() =>
                setLicenseTab('historial')
              }
              style={getActionStyle('historial')}
            >
              Historial
            </button>
          </div>

          {licenseTab === 'resumen' && (
            <LicenseTable />
          )}

          {licenseTab === 'transferir' && (
            <LicenseTransferForm />
          )}

          {licenseTab === 'asignar' && (
            <LicenseAssignForm />
          )}

          {licenseTab === 'renovar' && (
            <LicenseRenewForm />
          )}

          {licenseTab === 'historial' && (
            <LicenseHistoryTable />
          )}
        </div>
      )}
    </div>
  );
}


function CameraAdminPanel() {
  const { fetch } = useAccountScope();
  const isMobile = useIsMobile();
  const [cameras, setCameras] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [cameraId, setCameraId] = useState('');
  const [vehicleId, setVehicleId] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const selectedCamera = cameras.find(
    item => String(item.id) === String(cameraId)
  );

  async function cargarInventario(preferredCameraId = null) {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch('/api/cameras/admin/inventory', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'No se pudo consultar cámaras');
      }
      setCameras(data.cameras || []);
      setVehicles(data.vehicles || []);

      const wanted = preferredCameraId || cameraId;
      const next = (data.cameras || []).find(
        item => String(item.id) === String(wanted)
      ) || (data.cameras || [])[0] || null;

      setCameraId(next ? String(next.id) : '');
      setVehicleId(next?.vehicle_id ? String(next.vehicle_id) : '');
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Error cargando cámaras:', error);
      alert(error.message || 'No fue posible cargar las cámaras');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    cargarInventario();
  }, []);

  function seleccionarCamara(value) {
    setCameraId(value);
    const camera = cameras.find(item => String(item.id) === String(value));
    setVehicleId(camera?.vehicle_id ? String(camera.vehicle_id) : '');
  }

  async function guardarAsignacion() {
    if (!selectedCamera) {
      alert('Selecciona una cámara');
      return;
    }

    const target = vehicleId
      ? vehicles.find(item => String(item.id) === String(vehicleId))
      : null;

    if (target?.camera_id && Number(target.camera_id) !== Number(selectedCamera.id)) {
      alert(`El activo ya tiene vinculada la cámara ${target.camera_terminal_id}.`);
      return;
    }

    const currentLabel = selectedCamera.vehicle_name
      ? `${selectedCamera.vehicle_name} · ${selectedCamera.owner_name || 'sin titular'}`
      : 'Sin asignar';
    const targetLabel = target
      ? `${target.name} · ${target.owner_name || 'sin titular'}`
      : 'Sin asignar / desvincular';

    const ok = window.confirm(
      `¿Actualizar la asignación de la cámara ${selectedCamera.terminal_id}?\n\n` +
      `Actual: ${currentLabel}\n` +
      `Destino: ${targetLabel}`
    );
    if (!ok) return;

    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      const response = await fetch(
        `/api/cameras/admin/${selectedCamera.id}/assignment`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            vehicleId: target ? Number(target.id) : null
          })
        }
      );
      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'No se pudo actualizar la cámara');
      }
      alert(data.message || 'Asignación actualizada');
      await cargarInventario(selectedCamera.id);
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Error trasladando cámara:', error);
      alert(error.message || 'No fue posible actualizar la cámara');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{
      padding: isMobile ? '18px 14px 40px' : '28px 40px 48px',
      maxWidth: '1100px'
    }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '16px',
        padding: isMobile ? '18px' : '24px',
        boxShadow: '0 8px 24px rgba(15,23,42,0.06)'
      }}>
        <h2 style={{ margin: 0, color: '#0f172a', fontSize: isMobile ? '20px' : '24px' }}>
          Administración de cámaras
        </h2>
        <p style={{ color: '#64748b', lineHeight: 1.5 }}>
          Asigna, traslada o desvincula cámaras. El destino siempre es un activo concreto;
          la cámara adopta automáticamente la cuenta propietaria de ese activo.
        </p>

        {loading ? (
          <p style={{ color: '#64748b' }}>Cargando inventario…</p>
        ) : cameras.length === 0 ? (
          <p style={{ color: '#64748b' }}>No hay cámaras registradas.</p>
        ) : (
          <>
            <label style={{ display: 'block', fontWeight: 700, color: '#334155', marginTop: '18px' }}>
              Cámara
            </label>
            <select
              value={cameraId}
              onChange={event => seleccionarCamara(event.target.value)}
              style={{ width: '100%', marginTop: '8px', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1' }}
            >
              {cameras.map(camera => (
                <option key={camera.id} value={camera.id}>
                  {camera.terminal_id} · {camera.model || 'Sin referencia'} · {camera.online ? 'Online' : 'Offline'}
                  {camera.vehicle_name ? ` · ${camera.vehicle_name} / ${camera.owner_name || 'sin titular'}` : ' · Sin asignar'}
                </option>
              ))}
            </select>

            {selectedCamera && (
              <div style={{ marginTop: '14px', padding: '12px', borderRadius: '10px', background: '#f8fafc', color: '#475569' }}>
                <strong>{selectedCamera.terminal_id}</strong><br />
                Estado: {selectedCamera.online ? 'Online' : 'Offline'}<br />
                Asignación actual: {selectedCamera.vehicle_name
                  ? `${selectedCamera.vehicle_name} · ${selectedCamera.owner_name || 'sin titular'}${selectedCamera.company_name ? ` · ${selectedCamera.company_name}` : ''}`
                  : 'Sin asignar'}
              </div>
            )}

            <label style={{ display: 'block', fontWeight: 700, color: '#334155', marginTop: '18px' }}>
              Activo destino
            </label>
            <select
              value={vehicleId}
              onChange={event => setVehicleId(event.target.value)}
              style={{ width: '100%', marginTop: '8px', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1' }}
            >
              <option value="">Sin asignar / desvincular</option>
              {vehicles.map(vehicle => (
                <option
                  key={vehicle.id}
                  value={vehicle.id}
                  disabled={Boolean(vehicle.camera_id) && Number(vehicle.camera_id) !== Number(selectedCamera?.id)}
                >
                  {vehicle.company_name ? `${vehicle.company_name} · ` : ''}
                  {vehicle.owner_name || 'Sin titular'} · {vehicle.name || `Activo ${vehicle.id}`}
                  {vehicle.imei ? ` · ${vehicle.imei}` : ''}
                  {vehicle.camera_id && Number(vehicle.camera_id) !== Number(selectedCamera?.id)
                    ? ` · OCUPADO (${vehicle.camera_terminal_id})`
                    : ''}
                </option>
              ))}
            </select>

            <button
              onClick={guardarAsignacion}
              disabled={saving || !selectedCamera}
              style={{
                marginTop: '18px',
                padding: '12px 18px',
                border: 0,
                borderRadius: '10px',
                background: '#063b78',
                color: '#ffffff',
                fontWeight: 700,
                cursor: saving ? 'default' : 'pointer',
                opacity: saving ? 0.65 : 1
              }}
            >
              {saving ? 'Guardando…' : 'Guardar asignación'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function DeviceMovementForm() {
  const { fetch, account: scopeAccount } = useAccountScope();
  const isMobile = useIsMobile();

  const currentUser =
    scopeAccount;

  const [devices, setDevices] =
    useState([]);

  const [users, setUsers] =
    useState([]);

  const [companies, setCompanies] =
    useState([]);

  const [deviceId, setDeviceId] =
    useState('');

  const [targetCompanyId, setTargetCompanyId] =
    useState(
      currentUser.role === 'super_admin'
        ? ''
        : String(currentUser.company_id || '')
    );

  const [targetAdminId, setTargetAdminId] =
    useState(
      currentUser.role === 'administrador'
        ? String(currentUser.id || '')
        : ''
    );

  const [targetUserId, setTargetUserId] =
    useState('');
  const [targetCompanyOwnerId, setTargetCompanyOwnerId] = useState('');

  const [moveToMine, setMoveToMine] = useState(false);

  const [loading, setLoading] =
    useState(true);

  const [moving, setMoving] =
    useState(false);

  useEffect(() => {
    async function cargarDatos() {
      try {
        setLoading(true);

        const token =
          localStorage.getItem('token');

        const [
          devicesResponse,
          usersResponse,
          companiesResponse
        ] = await Promise.all([
          fetch('/api/admin/devices', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }),

          fetch('/api/users', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }),

          fetch('/api/companies', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          })
        ]);

        const devicesData =
          await devicesResponse.json();

        const usersData =
          await usersResponse.json();

        const companiesData =
          await companiesResponse.json();

        if (devicesData.success) {
          setDevices(
            devicesData.devices || []
          );
        }

        if (Array.isArray(usersData)) {
          setUsers(currentUser.role === 'administrador'
            ? [...usersData, currentUser]
            : usersData);
        } else if (
          Array.isArray(usersData.users)
        ) {
          setUsers(currentUser.role === 'administrador'
            ? [...usersData.users, currentUser]
            : usersData.users);
        }

        if (
          Array.isArray(companiesData)
        ) {
          setCompanies(companiesData);
        } else if (
          Array.isArray(
            companiesData.companies
          )
        ) {
          setCompanies(
            companiesData.companies
          );
        }

      } catch (error) {
      if (error?.name === 'AbortError') return;
        console.error(
          'Error cargando datos de movimientos:',
          error
        );

        alert(
          'Error cargando información de movimientos'
        );

      } finally {
        setLoading(false);
      }
    }

    cargarDatos();
  }, []);

  const selectedDevice =
    devices.find(
      (device) =>
        String(device.id) ===
        String(deviceId)
    );

  const selectedCompany =
    companies.find(
      (company) =>
        String(company.id) ===
        String(targetCompanyId)
    );

  const selectedAdmin =
    users.find(
      (user) =>
        String(user.id) ===
        String(targetAdminId)
    );

  const selectedUser =
    users.find(
      (user) =>
        String(user.id) ===
        String(targetUserId)
    );

  const companyOwners = users.filter(user =>
    user.role === 'admin_empresa' && user.status === 'active' &&
    String(user.company_id) === String(targetCompanyId));

  /*
    ==========================================
    EMPRESAS DISPONIBLES
    ==========================================
  */

  const empresasDestino =
    currentUser.role === 'super_admin'
      ? companies
      : companies.filter(
          (company) =>
            String(company.id) ===
            String(currentUser.company_id)
        );

  /*
    ==========================================
    ADMINISTRADORES DISPONIBLES
    ==========================================
  */

  const administradoresDestino =
    users.filter((user) => {
      if (
        user.role !== 'administrador' ||
        user.status !== 'active'
      ) {
        return false;
      }

      /*
        Un administrador solamente puede
        trabajar con su propia administración.
      */
      if (
        currentUser.role ===
        'administrador'
      ) {
        return (
          String(user.id) ===
          String(currentUser.id)
        );
      }

      /*
        Para super_admin y admin_empresa,
        el administrador debe pertenecer
        a la empresa seleccionada.
      */
      if (!targetCompanyId) {
        return false;
      }

      return (
        String(user.company_id) ===
        String(targetCompanyId)
      );
    });

  /*
    ==========================================
    USUARIOS DISPONIBLES
    ==========================================
  */

  const usuariosDestino =
    users.filter((user) => {
      if (
        user.role !== 'usuario' ||
        user.status !== 'active'
      ) {
        return false;
      }

      /*
        Siempre debe existir primero
        un administrador destino.
      */
      if (!targetAdminId) {
        return false;
      }

      return (
        String(user.parent_user_id) ===
          String(targetAdminId) &&
        String(user.company_id) ===
          String(targetCompanyId)
      );
    });

  /*
    ==========================================
    LIMPIAR DESTINO AL CAMBIAR EQUIPO
    ==========================================
  */

  function limpiarDestino() {
    setMoveToMine(false);
    setTargetCompanyOwnerId('');
    if (
      currentUser.role ===
      'super_admin'
    ) {
      setTargetCompanyId('');
      setTargetAdminId('');
      setTargetUserId('');
      return;
    }

    if (
      currentUser.role ===
      'admin_empresa'
    ) {
      setTargetCompanyId(
        String(
          currentUser.company_id || ''
        )
      );

      setTargetAdminId('');
      setTargetUserId('');
      return;
    }

    if (
      currentUser.role ===
      'administrador'
    ) {
      setTargetCompanyId(
        String(
          currentUser.company_id || ''
        )
      );

      setTargetAdminId(
        String(
          currentUser.id || ''
        )
      );

      setTargetUserId('');
    }
  }

  /*
    ==========================================
    DESCRIPCIÓN DEL DESTINO
    ==========================================
  */

  function obtenerDestino() {
    if (currentUser.role === 'super_admin' && moveToMine) {
      return { type: 'mi_cuenta', body: { target_type: 'mi_cuenta' }, label: 'Mi cuenta (Superadministrador)' };
    }
    /*
      Si existe usuario, el destino final
      es USUARIO.
    */
    if (targetUserId && selectedUser) {
      return {
        type: 'usuario',

        body: {
          target_type: 'usuario',
          user_id:
            Number(targetUserId)
        },

        label:
          `${selectedUser.name} ` +
          `(Usuario)`
      };
    }

    /*
      Si existe administrador pero no usuario,
      el equipo queda en ADMINISTRADOR.
    */
    if (
      targetAdminId &&
      selectedAdmin
    ) {
      return {
        type: 'administrador',

        body: {
          target_type:
            'administrador',

          admin_id:
            Number(targetAdminId)
        },

        label:
          `${selectedAdmin.name} ` +
          `(Administrador)`
      };
    }

    /*
      Si solamente existe empresa,
      el equipo queda a nivel EMPRESA.
    */
    if (
      targetCompanyId &&
      selectedCompany
    ) {
      return {
        type: 'empresa',

        body: {
          target_type: 'empresa',

          company_id:
            Number(targetCompanyId),
          ...(currentUser.role === 'super_admin' && companyOwners.length > 1
            ? { company_owner_user_id: Number(targetCompanyOwnerId) } : {})
        },

        label:
          `${selectedCompany.name} ` +
          `(Empresa)`
      };
    }

    return null;
  }

  /*
    ==========================================
    MOVER DISPOSITIVO
    ==========================================
  */

  async function moverDispositivo() {
    if (!deviceId) {
      alert(
        'Debes seleccionar un dispositivo'
      );

      return;
    }

    const destino =
      obtenerDestino();

    if (destino?.type === 'empresa' && currentUser.role === 'super_admin' &&
        companyOwners.length > 1 && !targetCompanyOwnerId) {
      alert('Selecciona la cuenta titular de esta empresa');
      return;
    }

    if (!destino) {
      alert(
        'Debes seleccionar al menos una empresa destino'
      );

      return;
    }

    const origenPartes = [];

    if (
      selectedDevice?.company_name
    ) {
      origenPartes.push(
        selectedDevice.company_name
      );
    }

    if (
      selectedDevice?.admin_name
    ) {
      origenPartes.push(
        selectedDevice.admin_name
      );
    }

    if (
      selectedDevice?.user_name
    ) {
      origenPartes.push(
        selectedDevice.user_name
      );
    }

    const origen =
      origenPartes.length > 0
        ? origenPartes.join(' → ')
        : 'MACCEZ / Sin asignación';

    const confirmado =
      window.confirm(
        `¿Deseas mover "${selectedDevice?.name || 'este dispositivo'}"?\n\n` +
        `Origen:\n${origen}\n\n` +
        `Nuevo destino:\n${destino.label}\n\n` +
        `El IMEI, licencia, histórico, fotografía y configuración se conservarán.`
      );

    if (!confirmado) {
      return;
    }

    try {
      setMoving(true);

      const token =
        localStorage.getItem('token');

      const response =
        await fetch(
          `/api/devices/${deviceId}/move`,
          {
            method: 'PATCH',

            headers: {
              'Content-Type':
                'application/json',

              Authorization:
                `Bearer ${token}`
            },

            body: JSON.stringify(
              destino.body
            )
          }
        );

      const data =
        await response.json();

      if (
        !response.ok ||
        !data.success
      ) {
        alert(
          data.message ||
          'No fue posible mover el dispositivo'
        );

        return;
      }

      alert(
        'Dispositivo movido correctamente'
      );

      /*
        Actualización local inmediata.

        Es importante asignar también NULL
        cuando el equipo sube de Usuario
        a Administrador o Empresa.
      */
      setDevices((previous) =>
        previous.map((device) => {
          if (
            String(device.id) !==
            String(deviceId)
          ) {
            return device;
          }

          const to =
            data.movement?.to || {};

          return {
            ...device,

            company_id:
              to.company_id ?? null,

            company_name:
              to.company_name ?? null,

            admin_id:
              to.admin_id ?? null,

            admin_name:
              to.admin_name ?? null,

            user_id:
              to.user_id ?? null,

            user_name:
              to.user_name ?? null
          };
        })
      );

      /*
        Dejamos seleccionado el equipo,
        pero limpiamos el destino para evitar
        ejecutar accidentalmente dos movimientos.
      */
      limpiarDestino();

    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(
        'Error moviendo dispositivo:',
        error
      );

      alert(
        'Error moviendo dispositivo'
      );

    } finally {
      setMoving(false);
    }
  }

  /*
    ==========================================
    CARGANDO
    ==========================================
  */

  if (loading) {
    return (
      <div
        style={
          isMobile
            ? placeholderStyleMobile
            : placeholderStyle
        }
      >
        Cargando movimientos...
      </div>
    );
  }

  /*
    ==========================================
    INTERFAZ
    ==========================================
  */

  return (
    <div
      style={
        isMobile
          ? placeholderStyleMobile
          : placeholderStyle
      }
    >
      <h3
        style={
          isMobile
            ? placeholderTitleMobile
            : placeholderTitle
        }
      >
        Movimiento de equipos
      </h3>

      <p style={placeholderText}>
        Reasigna un dispositivo dentro de la
        jerarquía Empresa → Administrador →
        Usuario, conservando su IMEI, licencia,
        histórico, fotografía y configuración.
      </p>

      {/* EQUIPO */}
      <div
        style={
          isMobile
            ? formGridMobile
            : formGrid
        }
      >
        <div>
          <label style={labelStyle}>
            Equipo
          </label>

          <select
            value={deviceId}
            onChange={(e) => {
              setDeviceId(
                e.target.value
              );

              limpiarDestino();
            }}
            style={inputStyle}
          >
            <option value="">
              Seleccionar equipo
            </option>

            {devices.map((device) => (
              <option
                key={device.id}
                value={device.id}
              >
                {device.name}
                {' · '}
                {device.imei}
              </option>
            ))}
          </select>
        </div>

        {currentUser.role === 'super_admin' && deviceId && (
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={moveToMine}
              onChange={event => {
                setMoveToMine(event.target.checked);
                if (event.target.checked) {
                  setTargetCompanyId(''); setTargetAdminId(''); setTargetUserId('');
                }
              }} />
            Devolver a mi cuenta
          </label>
        )}

        {/* EMPRESA */}
        <div>
          <label style={labelStyle}>
            Empresa destino
          </label>

          <select
            value={targetCompanyId}
            onChange={(e) => {
              setMoveToMine(false);
              setTargetCompanyId(
                e.target.value
              );

              setTargetCompanyOwnerId('');

              setTargetAdminId('');
              setTargetUserId('');
            }}
            disabled={
              !deviceId ||
              currentUser.role !==
                'super_admin' || moveToMine
            }
            style={{
              ...inputStyle,

              background:
                currentUser.role !==
                  'super_admin'
                  ? '#f8fafc'
                  : '#ffffff'
            }}
          >
            <option value="">
              Seleccionar empresa
            </option>

            {empresasDestino.map(
              (company) => (
                <option
                  key={company.id}
                  value={company.id}
                >
                  {company.name}
                </option>
              )
            )}
          </select>
        </div>

        {currentUser.role === 'super_admin' && targetCompanyId &&
          !targetAdminId && !targetUserId && !moveToMine && companyOwners.length > 1 && (
          <div>
            <label style={labelStyle}>Cuenta titular de la empresa</label>
            <select value={targetCompanyOwnerId} style={inputStyle}
              onChange={event => setTargetCompanyOwnerId(event.target.value)}>
              <option value="">Seleccionar titular</option>
              {companyOwners.map(owner => <option key={owner.id} value={owner.id}>
                {owner.name} · {owner.email}
              </option>)}
            </select>
          </div>
        )}

        {/* ADMINISTRADOR */}
        <div>
          <label style={labelStyle}>
            Administrador destino
            {' '}
            <span
              style={{
                color: '#94a3b8',
                fontWeight: '600'
              }}
            >
              (opcional)
            </span>
          </label>

          <select
            value={targetAdminId}
            onChange={(e) => {
              setMoveToMine(false);
              setTargetAdminId(
                e.target.value
              );

              setTargetUserId('');
            }}
            disabled={
              !deviceId ||
              !targetCompanyId || moveToMine ||
              currentUser.role ===
                'administrador'
            }
            style={{
              ...inputStyle,

              background:
                currentUser.role ===
                  'administrador'
                  ? '#f8fafc'
                  : '#ffffff'
            }}
          >
            <option value="">
              Dejar en empresa
            </option>

            {administradoresDestino.map(
              (admin) => (
                <option
                  key={admin.id}
                  value={admin.id}
                >
                  {admin.name}
                  {admin.email
                    ? ` · ${admin.email}`
                    : ''}
                </option>
              )
            )}
          </select>
        </div>

        {/* USUARIO */}
        <div>
          <label style={labelStyle}>
            Usuario destino
            {' '}
            <span
              style={{
                color: '#94a3b8',
                fontWeight: '600'
              }}
            >
              (opcional)
            </span>
          </label>

          <select
            value={targetUserId}
            onChange={(e) => {
              setMoveToMine(false);
              setTargetUserId(e.target.value);
            }}
            disabled={
              !deviceId ||
              !targetAdminId || moveToMine
            }
            style={inputStyle}
          >
            <option value="">
              Dejar en administrador
            </option>

            {usuariosDestino.map(
              (user) => (
                <option
                  key={user.id}
                  value={user.id}
                >
                  {user.name}
                  {user.email
                    ? ` · ${user.email}`
                    : ''}
                </option>
              )
            )}
          </select>
        </div>
      </div>

      {/* ASIGNACIÓN ACTUAL */}
      {selectedDevice && (
        <div
          style={{
            background: '#f8fafc',
            border:
              '1px solid #e2e8f0',
            borderRadius: '14px',
            padding: '16px',
            marginBottom: '20px'
          }}
        >
          <div
            style={{
              fontWeight: '800',
              color: '#0f172a',
              marginBottom: '10px'
            }}
          >
            Asignación actual
          </div>

          <div
            style={{
              color: '#64748b',
              fontSize: '14px',
              lineHeight: '1.7'
            }}
          >
            <div>
              <strong>
                Equipo:
              </strong>{' '}
              {selectedDevice.name}
            </div>

            <div>
              <strong>
                IMEI:
              </strong>{' '}
              {selectedDevice.imei}
            </div>

            <div>
              <strong>
                Empresa:
              </strong>{' '}
              {selectedDevice.company_name ||
                'MACCEZ / Sin empresa'}
            </div>

            <div>
              <strong>
                Administrador:
              </strong>{' '}
              {selectedDevice.admin_name ||
                'Sin administrador'}
            </div>

            <div>
              <strong>
                Usuario:
              </strong>{' '}
              {selectedDevice.user_name ||
                'Sin usuario asignado'}
            </div>
          </div>
        </div>
      )}

      {/* NUEVA ASIGNACIÓN */}
      {selectedDevice &&
        obtenerDestino() && (
          <div
            style={{
              background: '#eff6ff',
              border:
                '1px solid #bfdbfe',
              borderRadius: '14px',
              padding: '16px',
              marginBottom: '20px'
            }}
          >
            <div
              style={{
                fontWeight: '800',
                color: '#1e3a8a',
                marginBottom: '10px'
              }}
            >
              Nueva asignación
            </div>

            <div
              style={{
                color: '#475569',
                fontSize: '14px',
                lineHeight: '1.7'
              }}
            >
              <div>
                <strong>
                  Empresa:
                </strong>{' '}
                {selectedCompany?.name ||
                  moveToMine ? 'MACCEZ' : '—'}
              </div>

              <div>
                <strong>
                  Administrador:
                </strong>{' '}
                {selectedAdmin?.name ||
                  'Sin administrador'}
              </div>

              <div>
                <strong>
                  Usuario:
                </strong>{' '}
                {selectedUser?.name ||
                  'Sin usuario asignado'}
              </div>

              <div>
                <strong>
                  Nivel final:
                </strong>{' '}
                {moveToMine ? 'Mi cuenta' : targetUserId
                  ? 'Usuario'
                  : targetAdminId
                    ? 'Administrador'
                    : 'Empresa'}
              </div>
            </div>
          </div>
        )}

      <button
        style={
          isMobile
            ? primaryButtonMobile
            : primaryButton
        }
        disabled={
          !deviceId ||
          !obtenerDestino() ||
          moving
        }
        onClick={
          moverDispositivo
        }
      >
        {moving
          ? 'Moviendo equipo...'
          : 'Mover equipo'}
      </button>
    </div>
  );
}

function LicenseCard({
  title,
  value,
  description,
  isMobile
}) {
  return (
    <div style={isMobile ? cardStyleMobile : cardStyle}>
      <div style={cardTitle}>
        {title}
      </div>

      <div style={isMobile ? cardValueMobile : cardValue}>
        {value}
      </div>

      <div style={cardDescription}>
        {description}
      </div>
    </div>
  );
}

function LicenseTable() {
  const { fetch } = useAccountScope();
  const isMobile = useIsMobile();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    fetch('/api/licenses/expirations', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error consultando licencias');
      if (mounted) setRows(data.expirations || []);
    }).catch(err => { if (mounted) setError(err.message); });
    return () => { mounted = false; };
  }, []);

  return (
    <div style={isMobile ? tableContainerMobile : tableContainer}>
      <table style={tableStyle}>
        <thead>
          <tr style={tableHeadRow}>
            <th style={thStyle}>Licencia</th>
            <th style={thStyle}>Dispositivo</th>
            <th style={thStyle}>IMEI</th>
            <th style={thStyle}>Empresa</th>
            <th style={thStyle}>Activación</th>
            <th style={thStyle}>Vencimiento</th>
            <th style={thStyle}>Estado</th>
            <th style={thStyle}>Próxima vigencia</th>
          </tr>
        </thead>

        <tbody>
          {error && <tr><td style={tdStyle} colSpan="8">{error}</td></tr>}
          {!error && rows.length === 0 && <tr><td style={tdStyle} colSpan="8">No hay activos registrados.</td></tr>}
          {rows.map(row => (
            <tr key={row.vehicle_id}>
              <td style={tdStyle}>{row.license_key || '—'}</td>
              <td style={tdStyle}>{row.vehicle_name}</td>
              <td style={tdStyle}>{row.imei}</td>
              <td style={tdStyle}>{row.company_name || 'MACCEZ'}</td>
              <td style={tdStyle}>{row.activated_at ? formatearFecha(row.activated_at) : '—'}</td>
              <td style={tdStyle}>{row.expires_at ? formatearFecha(row.expires_at) : '—'}</td>
              <td style={tdStyle}>{({active: 'Activa', expiring: 'Por vencer', expired: 'Vencida', unlicensed: 'Sin licencia', suspended: 'Suspendida'})[row.effective_status] || row.effective_status}</td>
              <td style={tdStyle}>{row.next_activation ? `Renovada desde ${formatearFecha(row.next_activation)}` : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function LicenseRenewForm() {
  const { fetch, refreshAccountScope } = useAccountScope();
  const isMobile = useIsMobile();
  const [imei, setImei] = useState('');
  const [busy, setBusy] = useState(false);

  async function renovar() {
    if (!imei.trim() || busy) return;
    if (!window.confirm(`Se descontará una licencia disponible para renovar el IMEI ${imei.trim()}. ¿Continuar?`)) return;
    setBusy(true);
    try {
      const response = await fetch('/api/licenses/renew', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ imei: imei.trim() })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'No se pudo renovar');
      alert(`Licencia renovada. Vence: ${formatearFecha(data.result.expires_at)}`);
      refreshAccountScope();
    } catch (error) {
      if (error?.name === 'AbortError') return;
      alert(error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={isMobile ? placeholderStyleMobile : placeholderStyle}>
      <h3 style={isMobile ? placeholderTitleMobile : placeholderTitle}>Renovar licencia</h3>
      <p style={placeholderText}>Descuenta una licencia disponible. Si la actual está vigente, los nuevos 365 días comienzan al vencimiento; si venció, comienzan hoy.</p>
      <label style={labelStyle}>IMEI del activo</label>
      <input style={inputStyle} value={imei} onChange={e => setImei(e.target.value)} placeholder="IMEI registrado" />
      <button style={isMobile ? primaryButtonMobile : primaryButton} onClick={renovar} disabled={busy}>
        {busy ? 'Renovando…' : 'Renovar licencia'}
      </button>
    </div>
  );
}

function LicenseAssignForm() {
  const { fetch, refreshAccountScope } = useAccountScope();
  const isMobile = useIsMobile();

  const [imei, setImei] =
    useState('');

  async function asignarLicencia() {
    try {
      if (!imei) {
        alert('Debes escribir el IMEI');
        return;
      }

      const token =
        localStorage.getItem('token');

      const response =
        await fetch(
          '/api/licenses/assign-device',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Authorization:
                `Bearer ${token}`
            },
            body: JSON.stringify({
              imei
            })
          }
        );

      const data =
        await response.json();

      if (data.success) {
        alert(
          'Licencia asignada correctamente'
        );

        refreshAccountScope();
      } else {
        alert(data.message);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);

      alert(
        'Error asignando licencia'
      );
    }
  }

  return (
    <div style={isMobile ? placeholderStyleMobile : placeholderStyle}>
      <h3 style={isMobile ? placeholderTitleMobile : placeholderTitle}>
        Asignar licencia a IMEI
      </h3>

      <p style={placeholderText}>
        Se descontará una licencia disponible de tu stock y se activará por 365 días para el IMEI indicado.
      </p>

      <div style={isMobile ? formGridMobile : formGrid}>
        <div>
          <label style={labelStyle}>
            IMEI del dispositivo
          </label>

          <input
            value={imei}
            onChange={(e) =>
              setImei(e.target.value)
            }
            placeholder="Ej: 863000000000001"
            style={inputStyle}
          />
        </div>
      </div>

      <button
        style={isMobile ? primaryButtonMobile : primaryButton}
        onClick={asignarLicencia}
      >
        Asignar licencia
      </button>
    </div>
  );
}

function LicenseHistoryTable() {
  const { fetch } = useAccountScope();
  const isMobile = useIsMobile();

  const [history, setHistory] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [filter, setFilter] =
    useState('all');

  const filteredHistory =
    filter === 'all'
      ? history
      : history.filter(
          (item) =>
            item.action_type === filter
        );

  useEffect(() => {
    async function cargarHistorial() {
      try {
        const token =
          localStorage.getItem('token');

        const response =
          await fetch('/api/licenses/history', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          });

        const data =
          await response.json();

        if (data.success) {
          setHistory(data.history || []);
        }
      } catch (error) {
      if (error?.name === 'AbortError') return;
        console.error(
          'Error cargando historial de licencias:',
          error
        );
      } finally {
        setLoading(false);
      }
    }

    cargarHistorial();
  }, []);

  function traducirAccion(action) {
    if (action === 'created_batch') return 'Lote creado';
    if (action === 'transfer') return 'Transferencia';
    if (action === 'assigned_device') return 'Asignación a IMEI';
    if (action === 'renew') return 'Renovación';

    return action;
  }

  function getHistoryBadgeStyle(action) {
    const base = {
      padding: '5px 12px',
      borderRadius: '999px',
      fontSize: '12px',
      fontWeight: '800',
      whiteSpace: 'nowrap'
    };

    if (action === 'created_batch') {
      return {
        ...base,
        background: '#dbeafe',
        color: '#1d4ed8'
      };
    }

    if (action === 'transfer') {
      return {
        ...base,
        background: '#ffedd5',
        color: '#c2410c'
      };
    }

    if (action === 'assigned_device') {
      return {
        ...base,
        background: '#dcfce7',
        color: '#166534'
      };
    }

    if (action === 'renew') {
      return {
        ...base,
        background: '#f3e8ff',
        color: '#7e22ce'
      };
    }

    return {
      ...base,
      background: '#f1f5f9',
      color: '#334155'
    };
  }

  if (loading) {
    return (
      <div style={isMobile ? placeholderStyleMobile : placeholderStyle}>
        Cargando historial...
      </div>
    );
  }

  return (
    <div style={isMobile ? tableContainerMobile : tableContainer}>
      <h3 style={isMobile ? placeholderTitleMobile : placeholderTitle}>
        Historial de licencias
      </h3>

      <p style={placeholderText}>
        Auditoría de creación, transferencias,
        asignaciones, renovaciones y cambios
        de licencias.
      </p>

      <div style={isMobile ? historyToolbarMobile : historyToolbar}>
        <div style={historyCount}>
          {filteredHistory.length} movimiento(s)
        </div>

        <select
          value={filter}
          onChange={(e) =>
            setFilter(e.target.value)
          }
          style={isMobile ? historyFilterMobile : historyFilter}
        >
          <option value="all">Todas</option>
          <option value="created_batch">Lote creado</option>
          <option value="transfer">Transferencias</option>
          <option value="assigned_device">Asignaciones IMEI</option>
          <option value="renew">Renovaciones</option>
        </select>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr style={tableHeadRow}>
            <th style={thStyle}>Fecha</th>
            <th style={thStyle}>Acción</th>
            <th style={thStyle}>Cantidad</th>
            <th style={thStyle}>IMEI</th>
            <th style={thStyle}>Ejecutado por</th>
            <th style={thStyle}>Usuario destino</th>
            <th style={thStyle}>Empresa origen</th>
            <th style={thStyle}>Empresa destino</th>
            <th style={thStyle}>Detalle</th>
          </tr>
        </thead>

        <tbody>
          {filteredHistory.length === 0 && (
            <tr>
              <td
                style={tdStyle}
                colSpan="9"
              >
                No hay movimientos registrados.
              </td>
            </tr>
          )}

          {filteredHistory.map((item) => (
            <tr key={item.id}>
              <td style={tdStyle}>
                {formatearFecha(item.created_at)}
              </td>

              <td style={tdStyle}>
                <span style={getHistoryBadgeStyle(item.action_type)}>
                  {traducirAccion(item.action_type)}
                </span>
              </td>

              <td style={tdStyle}>
                {item.quantity || '—'}
              </td>

              <td style={tdStyle}>
                {item.imei || '—'}
              </td>

              <td style={tdStyle}>
                <strong>
                  {item.executed_by_name || '—'}
                </strong>
              </td>

              <td style={tdStyle}>
                {item.to_user_name || '—'}
              </td>

              <td style={tdStyle}>
                {item.from_company_name || '—'}
              </td>

              <td style={tdStyle}>
                {item.to_company_name || '—'}
              </td>

              <td style={detailTdStyle}>
                <span title={item.notes || ''}>
                  {item.notes || '—'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function LicenseTransferForm() {
  const { fetch, account: scopeAccount, refreshAccountScope } = useAccountScope();
  const isMobile = useIsMobile();

  const user =
    scopeAccount;

  const role =
    user.role;

  const [tipoDestino, setTipoDestino] =
    useState(
      role === 'super_admin'
        ? 'empresa'
        : 'administrador'
    );

  const [usuarios, setUsuarios] =
    useState([]);

  const [empresas, setEmpresas] =
    useState([]);

  const [destinoId, setDestinoId] =
    useState('');

  const [cantidad, setCantidad] =
    useState(1);

  useEffect(() => {
    async function cargarDatos() {
      try {
        const token =
          localStorage.getItem('token');

        const usersResponse =
          await fetch('/api/users', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          });

        const usersData =
          await usersResponse.json();

        if (Array.isArray(usersData)) {
          setUsuarios(usersData);
        }

        const companiesResponse =
          await fetch('/api/companies', {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          });

        const companiesData =
          await companiesResponse.json();

        if (Array.isArray(companiesData)) {
          setEmpresas(companiesData);
        }

        if (Array.isArray(companiesData.companies)) {
          setEmpresas(companiesData.companies);
        }
      } catch (error) {
      if (error?.name === 'AbortError') return;
        console.error(
          'Error cargando destinos:',
          error
        );
      }
    }

    cargarDatos();
  }, []);

  const opcionesDestino =
    tipoDestino === 'empresa'
      ? empresas
      : usuarios.filter(
          (usuario) =>
            usuario.role === tipoDestino && usuario.status === 'active'
        );

  async function transferirLicencias() {
    try {
      if (!destinoId) {
        alert(
          'Debes seleccionar un destino'
        );
        return;
      }

      const token =
        localStorage.getItem('token');

      const response =
        await fetch(
          '/api/licenses/transfer',
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Authorization:
                `Bearer ${token}`
            },
            body: JSON.stringify({
              ownerType: tipoDestino,
              ownerId: destinoId,
              quantity:
                Number(cantidad)
            })
          }
        );

      const data =
        await response.json();

      if (data.success) {
        alert(
          `Transferidas ${cantidad} licencia(s)`
        );

        refreshAccountScope();
      } else {
        alert(data.message);
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error(error);

      alert(
        'Error transfiriendo licencias'
      );
    }
  }

  return (
    <div style={isMobile ? placeholderStyleMobile : placeholderStyle}>
      <h3 style={isMobile ? placeholderTitleMobile : placeholderTitle}>
        Transferir licencias
      </h3>

      <p style={placeholderText}>
        Transfiere stock de licencias según la jerarquía permitida.
      </p>

      <div style={isMobile ? formGridMobile : formGrid}>
        <div>
          <label style={labelStyle}>
            Tipo de destino
          </label>

          <select
            value={tipoDestino}
            onChange={(e) => {
              setTipoDestino(e.target.value);
              setDestinoId('');
            }}
            style={inputStyle}
          >
            {role === 'super_admin' && (
              <option value="empresa">
                Empresa
              </option>
            )}

            {(role === 'super_admin' ||
              role === 'admin_empresa') && (
              <option value="administrador">
                Administrador
              </option>
            )}

            {(role === 'super_admin' || role === 'admin_empresa') && (
              <option value="usuario">Usuario</option>
            )}
          </select>
        </div>

        <div>
          <label style={labelStyle}>
            {tipoDestino === 'empresa'
              ? 'Empresa destino'
              : tipoDestino === 'usuario' ? 'Usuario destino' : 'Administrador destino'}
          </label>

          <select
            value={destinoId}
            onChange={(e) =>
              setDestinoId(e.target.value)
            }
            style={inputStyle}
          >
            <option value="">
              {tipoDestino === 'empresa'
                ? 'Seleccionar empresa'
                : tipoDestino === 'usuario' ? 'Seleccionar usuario' : 'Seleccionar administrador'}
            </option>

            {opcionesDestino.map((item) => (
              <option
                key={item.id}
                value={item.id}
              >
                {item.name || item.company_name}
                {item.email
                  ? ` - ${item.email}`
                  : ''}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={labelStyle}>
            Cantidad de licencias
          </label>

          <input
            type="number"
            min="1"
            value={cantidad}
            onChange={(e) =>
              setCantidad(e.target.value)
            }
            style={inputStyle}
          />
        </div>
      </div>

      <button
        style={isMobile ? primaryButtonMobile : primaryButton}
        onClick={transferirLicencias}
      >
        Transferir licencias
      </button>
    </div>
  );
}

const titleStyle = {
  margin: 0,
  fontSize: '32px',
  color: '#0f172a'
};

const titleStyleMobile = {
  ...titleStyle,
  fontSize: '24px'
};

const subtitleStyle = {
  color: '#64748b',
  marginTop: '8px',
  marginBottom: '24px'
};

const subtitleStyleMobile = {
  ...subtitleStyle,
  fontSize: '13px',
  marginBottom: '16px',
  lineHeight: '1.4'
};

const tabsContainer = {
  display: 'flex',
  gap: '12px'
};

const tabsContainerMobile = {
  display: 'flex',
  gap: '8px',
  overflowX: 'auto',
  paddingBottom: '10px',
  WebkitOverflowScrolling: 'touch'
};

const tabStyle = {
  border: '1px solid #e2e8f0',
  background: '#ffffff',
  color: '#334155',
  borderRadius: '12px',
  padding: '12px 18px',
  cursor: 'pointer',
  fontWeight: '700'
};

const tabActive = {
  ...tabStyle,
  background: '#2563eb',
  color: '#ffffff',
  border: '1px solid #2563eb'
};

const tabStyleMobile = {
  ...tabStyle,
  padding: '10px 14px',
  borderRadius: '999px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  flex: '0 0 auto'
};

const tabActiveMobile = {
  ...tabStyleMobile,
  background: '#2563eb',
  color: '#ffffff',
  border: '1px solid #2563eb'
};

const licenseWrapper = {
  padding: '28px 40px 40px'
};

const licenseWrapperMobile = {
  padding: '18px 14px 26px'
};

const licenseHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px'
};

const licenseHeaderMobile = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '14px',
  marginBottom: '18px'
};

const sectionTitle = {
  margin: 0,
  fontSize: '24px',
  color: '#0f172a'
};

const sectionTitleMobile = {
  ...sectionTitle,
  fontSize: '20px'
};

const sectionSubtitle = {
  marginTop: '8px',
  color: '#64748b'
};

const sectionSubtitleMobile = {
  ...sectionSubtitle,
  fontSize: '13px',
  lineHeight: '1.4'
};

const primaryButton = {
  background: '#2563eb',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  padding: '12px 18px',
  cursor: 'pointer',
  fontWeight: '700'
};

const primaryButtonMobile = {
  ...primaryButton,
  width: '100%',
  padding: '12px 14px'
};

const cardsGrid = {
  display: 'grid',
  gridTemplateColumns:
    'repeat(4, minmax(180px, 1fr))',
  gap: '16px',
  marginBottom: '24px'
};

const cardsGridMobile = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px',
  marginBottom: '18px'
};

const cardStyle = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '18px',
  padding: '22px',
  boxShadow:
    '0 8px 24px rgba(15,23,42,0.06)',
  minHeight: '120px'
};

const cardStyleMobile = {
  ...cardStyle,
  padding: '14px',
  minHeight: '92px',
  borderRadius: '16px'
};

const cardTitle = {
  color: '#64748b',
  fontSize: '13px',
  fontWeight: '700',
  marginBottom: '10px'
};

const cardValue = {
  fontSize: '30px',
  fontWeight: '800',
  color: '#0f172a'
};

const cardValueMobile = {
  ...cardValue,
  fontSize: '24px'
};

const cardDescription = {
  marginTop: '6px',
  color: '#94a3b8',
  fontSize: '13px'
};

const licenseActions = {
  display: 'flex',
  gap: '12px',
  marginBottom: '24px'
};

const licenseActionsMobile = {
  display: 'flex',
  gap: '8px',
  marginBottom: '18px',
  overflowX: 'auto',
  paddingBottom: '8px',
  WebkitOverflowScrolling: 'touch'
};

const actionButton = {
  border: '1px solid #dbeafe',
  background: '#ffffff',
  color: '#1e40af',
  borderRadius: '12px',
  padding: '13px 18px',
  cursor: 'pointer',
  fontWeight: '800',
  boxShadow:
    '0 4px 14px rgba(15,23,42,0.05)'
};

const actionButtonActive = {
  ...actionButton,
  background: '#2563eb',
  color: '#ffffff',
  border: '1px solid #2563eb'
};

const actionButtonMobile = {
  ...actionButton,
  padding: '10px 14px',
  borderRadius: '999px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  flex: '0 0 auto'
};

const actionButtonActiveMobile = {
  ...actionButtonMobile,
  background: '#2563eb',
  color: '#ffffff',
  border: '1px solid #2563eb'
};

const tableContainer = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '18px',
  padding: '22px',
  boxShadow:
    '0 8px 24px rgba(15,23,42,0.06)',
  minHeight: '120px',
  overflowX: 'auto'
};

const tableContainerMobile = {
  ...tableContainer,
  padding: '14px',
  borderRadius: '16px',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  minWidth: '860px'
};

const tableHeadRow = {
  background: '#f8fafc'
};

const thStyle = {
  textAlign: 'left',
  padding: '16px',
  color: '#64748b',
  fontSize: '13px',
  fontWeight: '700'
};

const tdStyle = {
  padding: '16px',
  borderTop: '1px solid #f1f5f9',
  color: '#334155',
  fontSize: '14px'
};

const placeholderStyle = {
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '18px',
  padding: '28px',
  boxShadow:
    '0 8px 24px rgba(15,23,42,0.06)',
  margin: '28px 40px 40px'
};

const placeholderStyleMobile = {
  ...placeholderStyle,
  margin: '18px 14px 26px',
  padding: '18px',
  borderRadius: '16px'
};

const placeholderTitle = {
  margin: 0,
  fontSize: '22px',
  color: '#0f172a'
};

const placeholderTitleMobile = {
  ...placeholderTitle,
  fontSize: '18px'
};

const placeholderText = {
  marginTop: '10px',
  color: '#64748b',
  maxWidth: '620px',
  lineHeight: '1.45'
};

const formGrid = {
  display: 'grid',
  gridTemplateColumns:
    'repeat(3, minmax(180px, 1fr))',
  gap: '16px',
  marginTop: '24px',
  marginBottom: '24px'
};

const formGridMobile = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '14px',
  marginTop: '18px',
  marginBottom: '18px'
};

const labelStyle = {
  display: 'block',
  fontSize: '13px',
  color: '#64748b',
  fontWeight: '700',
  marginBottom: '8px'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  border: '1px solid #e2e8f0',
  borderRadius: '10px',
  outline: 'none',
  fontWeight: '600',
  color: '#0f172a',
  background: '#ffffff',
  boxSizing: 'border-box'
};

const historyToolbar = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '18px',
  marginBottom: '18px'
};

const historyToolbarMobile = {
  ...historyToolbar,
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '10px'
};

const historyCount = {
  color: '#64748b',
  fontSize: '14px',
  fontWeight: '700'
};

const historyFilter = {
  border: '1px solid #e2e8f0',
  borderRadius: '10px',
  padding: '10px 14px',
  fontWeight: '700',
  color: '#0f172a',
  background: '#ffffff'
};

const historyFilterMobile = {
  ...historyFilter,
  width: '100%',
  boxSizing: 'border-box'
};

const detailTdStyle = {
  ...tdStyle,
  maxWidth: '260px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export default AdministrationPage;
